import React, { useEffect, useState } from 'react';
import { scrollToBuy } from '../config';
import { ArrowRight } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function StickyMobileCta() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling down 500px, hide if near bottom to not overlap footer
      const scrollY = window.scrollY;
      const isNearBottom = window.innerHeight + scrollY >= document.body.offsetHeight - 800;
      if (scrollY > 500 && !isNearBottom) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-260">
      {isVisible && <motion.div initial={{
      y: 100
    }} animate={{
      y: 0
    }} exit={{
      y: 100
    }} className="fixed bottom-0 left-0 right-0 p-4 bg-white border-t border-gray-200 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)] z-40 md:hidden" data-id="element-261">
          <button onClick={scrollToBuy} className="w-full flex items-center justify-center gap-2 bg-brand-accent text-white font-bold py-3 px-4 rounded-lg shadow-lg" data-id="element-262">
            Quiero el Arsenal Ahora
            <ArrowRight className="w-4 h-4" data-id="element-263" />
          </button>
        </motion.div>}
    </AnimatePresence>;
}